<script>
  import UserUtil from '@/util/UserUtil'

  export default {
    data () {
      return {
        vm: {
          loading: false,
          msj: '',
          settings: {},
          loginFailed: false,
          usernameInvalido: false,
          passInvalido: false
        },
        loginLogo: require('CustomModules/GlobalBPOCore/assets/logoRH2.png')
      }
    },
    mounted () {
      this.initEvents()
      this.vm.settings.title = this.$store.state.appSettings.title
      if (this.$store.state.appSettings.logos.globalLoginLogo) {
        this.loginLogo = require(`CustomModules/GlobalBPOCore/assets/${this.$store.state.appSettings.logos.globalLoginLogo}`)
      }
    },
    methods: {
      empty (x) {
        return typeof x === 'undefined' || x === null || x === ''
      },
      login: function (e) {
        if (this.vm.loading) { return }

        this.vm.usernameInvalido = this.vm.passInvalido = false

        if (this.empty(this.vm.username)) {
          this.vm.usernameInvalido = true
        }
        if (this.empty(this.vm.password)) {
          this.vm.passInvalido = true
        }

        if (this.vm.usernameInvalido || this.vm.passInvalido) { return }

        this.vm.loading = true
        this.vm.loginFailed = false

        /* animacion */
        let btn = jQuery('.button')
        let oX = parseInt(btn.offset().left)
        let oY = parseInt(btn.offset().top)
        let pX = e.pageX || oX + 100
        let pY = e.pageY || oY + 50

        btn.append('<span class="click-efect x-' + oX + ' y-' + oY + '" style="margin-left:' + (pX - oX) + 'px;margin-top:' + (pY - oY) + 'px;"></span>')
        jQuery('.x-' + oX + '.y-' + oY + '').animate({
          'width': '500px',
          'height': '500px',
          'top': '-250px',
          'left': '-250px'
        }, 600)
        /* animacion */

        UserUtil.login(this.vm.username, this.vm.password, (response) => {
          btn.addClass('active')
          if (this.$store.state.lastRoute === null || this.$store.state.lastRoute.name === '' || this.$store.state.lastRoute.name === null) {
            this.$router.push({path: this.$store.state.userInfo.menu[0].path})
          } else {
            this.$router.push({
              path: this.$store.state.lastRoute.path
            })
          }
        }, (error) => {
          jQuery('.click-efect').fadeOut(400, () => {
            jQuery('.click-efect').remove()
          })

          this.vm.loginFailed = true
          this.vm.loading = false
          if (error.response && error.response.status === 401) {
            this.vm.msj = 'Usuario o contraseña incorrecta'
          } else if (error.response && error.response.status === 403) {
            this.vm.msj = 'Su usuario no tiene permisos para utilizar esta aplicación, contacte al adminsitrador.'
          } else {
            this.vm.msj = 'Error desconocido, contacte al administrador'
          }
        })
      },
      passwordRecovery () {
        this.$router.push({
          name: 'Password Recovery'
        })
      },
      initEvents () {
        jQuery('.input input').focus(function () {

          jQuery(this).parent('.input').each(function () {
            jQuery('label', this).css({
              'line-height': '18px',
              'font-size': '18px',
              'font-weight': '100',
              'top': '0px'
            })
            jQuery('.spin', this).css({
              'width': '100%'
            })
          })
        }).blur(function () {
          jQuery('.spin').css({
            'width': '0px'
          })
          if (jQuery(this).val() === '') {
            jQuery(this).parent('.input').each(function () {
              jQuery('label', this).css({
                'line-height': '60px',
                'font-size': '24px',
                'font-weight': '300',
                'top': '10px'
              })
            })
          }
        })

        jQuery('.alt-2').click(function () {
          if (!jQuery(this).hasClass('material-button')) {
            jQuery('.shape').css({
              'width': '100%',
              'height': '100%',
              'transform': 'rotate(0deg)'
            })

            setTimeout(function () {
              jQuery('.overbox').css({
                'overflow': 'initial'
              })
            }, 600)

            jQuery(this).animate({
              'width': '140px',
              'height': '140px'
            }, 500, function () {
              jQuery('.box').removeClass('back')

              jQuery(this).removeClass('active')
            })

            jQuery('.overbox .title').fadeOut(300)
            jQuery('.overbox .input').fadeOut(300)
            jQuery('.overbox .button').fadeOut(300)

            jQuery('.alt-2').addClass('material-buton')
          }
        })

        jQuery('.material-button').click(function () {
          if (jQuery(this).hasClass('material-button')) {
            setTimeout(function () {
              jQuery('.overbox').css({
                'overflow': 'hidden'
              })
              jQuery('.box').addClass('back')
            }, 200)
            jQuery(this).addClass('active').animate({
              'width': '700px',
              'height': '700px'
            })

            setTimeout(function () {
              jQuery('.shape').css({
                'width': '50%',
                'height': '50%',
                'transform': 'rotate(45deg)'
              })

              jQuery('.overbox .title').fadeIn(300)
              jQuery('.overbox .input').fadeIn(300)
              jQuery('.overbox .button').fadeIn(300)
            }, 700)

            jQuery(this).removeClass('material-button')
          }

          if (jQuery('.alt-2').hasClass('material-buton')) {
            jQuery('.alt-2').removeClass('material-buton')
            jQuery('.alt-2').addClass('material-button')
          }
        })
      }
    }
  }
</script>
<template src="./Login.html"></template>
<style>
  #login .box {
    position: relative;
    top: 0;
    opacity: 1;
    float: left;
    padding: 60px 50px 40px 50px;
    width: 100%;
    background: #fff;
    border-radius: 10px;
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    z-index: 5;
  }

  #login .box.back {
    transform: scale(.95);
    -webkit-transform: scale(.95);
    -ms-transform: scale(.95);
    top: -20px;
    opacity: .8;
    z-index: -1;
  }

  #login .box:before {
    content: "";
    width: 100%;
    height: 30px;
    border-radius: 10px;
    position: absolute;
    top: -10px;
    background: rgba(255, 255, 255, .6);
    left: 0;
    transform: scale(.95);
    -webkit-transform: scale(.95);
    -ms-transform: scale(.95);
    z-index: -1;
  }

  #login .overbox .title {
    color: #fff;
  }

  .overbox .title:before {
    background: #fff;
  }

  #login .title {
    width: 100%;
    float: left;
    line-height: 46px;
    font-size: 34px;
    font-weight: 700;
    letter-spacing: 2px;
    color: #15a512;
    position: relative;
  }

  #login .title:before {
    content: "";
    width: 5px;
    height: 100%;
    position: absolute;
    top: 0;
    left: -50px;
    background: #15a512;
  }

  #login .input,
  #login .input label,
  #login .input input,
  #login .input .spin,
  #login .button,
  #login .button button .button.login button i.fa,
  #login .material-button .shape:before,
  #login .material-button .shape:after,
  #login .button.login button {
    transition: 300ms cubic-bezier(.4, 0, .2, 1);
    -webkit-transition: 300ms cubic-bezier(.4, 0, .2, 1);
    -ms-transition: 300ms cubic-bezier(.4, 0, .2, 1);
  }

  #login .material-button,
  #login .alt-2,
  #login .material-button .shape,
  #login .alt-2 .shape,
  #login .box {
    transition: 400ms cubic-bezier(.4, 0, .2, 1);
    -webkit-transition: 400ms cubic-bezier(.4, 0, .2, 1);
    -ms-transition: 400ms cubic-bezier(.4, 0, .2, 1);
  }

  #login .input,
  #login .input label,
  #login .input input,
  #login .input .spin,
  #login .button,
  #login .button button {
    width: 100%;
    float: left;
  }

  #login .input,
  #login .button {
    margin-top: 30px;
    height: 70px;
  }

  #login .input,
  #login .input input,
  #login .button,
  #login .button button {
    position: relative;
  }

  #login .input input {
    height: 60px;
    top: 10px;
    border: none;
    background: transparent;
  }

  #login .input input,
  #login .input label,
  #login .button button {
    font-family: 'Roboto', sans-serif;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 300;
  }

  #login .input:before,
  #login .input .spin {
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  #login .input:before {
    content: "";
    background: rgba(0, 0, 0, 0.1);
    z-index: 3;
  }

  #login .input .spin {
    background: #15a512;
    z-index: 4;
    width: 0;
  }

  #login .overbox .input .spin {
    background: rgba(255, 255, 255, 1);
  }

  #login .overbox .input:before {
    background: rgba(255, 255, 255, 0.5);
  }

  #login .input label {
    position: absolute;
    top: 10px;
    left: 0;
    z-index: 2;
    cursor: pointer;
    line-height: 60px;
  }

  #login .button.login {
    width: 60%;
    left: 20%;
  }

  #login .button.login button,
  #login .button button {
    width: 100%;
    line-height: 64px;
    left: 0%;
    background-color: transparent;
    border: 3px solid rgba(0, 0, 0, 0.1);
    font-weight: 900;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.2);
  }

  #login .button.login {
    margin-top: 30px;
  }

  #login .button {
    margin-top: 20px;
  }

  #login .button button {
    background-color: #fff;
    color: #15a512;
    border: none;
  }

  #login .button.login button.active {
    border: 3px solid transparent;
    color: #fff !important;
  }

  #login .button.login button.active span {
    opacity: 0;
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
  }

  #login .button.login button.active i.fa {
    opacity: 1;
    transform: scale(1) rotate(-0deg);
    -webkit-transform: scale(1) rotate(-0deg);
    -ms-transform: scale(1) rotate(-0deg);
  }

  #login .button.login button i.fa {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 60px;
    transform: scale(0) rotate(-45deg);
    -webkit-transform: scale(0) rotate(-45deg);
    -ms-transform: scale(0) rotate(-45deg);
  }

  #login .button.login button:hover {
    color: #15a512;
    border-color: #15a512;
  }

  #login .button {
    margin: 15px 0;
    overflow: hidden;
    z-index: 2;
  }

  #login .button button {
    cursor: pointer;
    position: relative;
    z-index: 2;
  }

  #login .pass-forgot {
    width: 100%;
    float: left;
    text-align: center;
    color: rgba(0, 0, 0, 0.4);
    font-size: 18px;
  }

  #login .click-efect {
    position: absolute;
    top: 0;
    left: 0;
    background: #15a512;
    border-radius: 50%;
  }

  #login .overbox {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: inherit;
    border-radius: 10px;
    padding: 60px 50px 40px 50px;
  }

  #login .overbox .title,
  #login .overbox .button,
  #login .overbox .input {
    z-index: 111;
    position: relative;
    color: #fff !important;
    display: none;
  }

  #login .overbox .title {
    width: 80%;
  }

  #login .overbox .input {
    margin-top: 20px;
  }

  #login .overbox .input input,
  #login .overbox .input label {
    color: #fff;
  }

  #login .overbox .material-button,
  #login .overbox .material-button .shape,
  #login .overbox .alt-2,
  #login .overbox .alt-2 .shape {
    display: block;
  }

  #login .material-button,
  #login .alt-2 {
    width: 140px;
    height: 140px;
    border-radius: 50%;
    background: #15a512;
    position: absolute;
    top: 40px;
    right: -70px;
    cursor: pointer;
    z-index: 100;
    transform: translate(0%, 0%);
    -webkit-transform: translate(0%, 0%);
    -ms-transform: translate(0%, 0%);
  }

  #login .material-button .shape,
  #login .alt-2 .shape {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }

  #login .material-button .shape:before,
  #login .alt-2 .shape:before,
  #login .material-button .shape:after,
  #login .alt-2 .shape:after {
    content: "";
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(360deg);
    -webkit-transform: translate(-50%, -50%) rotate(360deg);
    -ms-transform: translate(-50%, -50%) rotate(360deg);
  }

  #login .material-button .shape:before,
  #login .alt-2 .shape:before {
    width: 25px;
    height: 4px;
  }

  #login .material-button .shape:after,
  #login .alt-2 .shape:after {
    height: 25px;
    width: 4px;
  }

  #login .material-button.active,
  #login .alt-2.active {
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%) rotate(0deg);
    -webkit-transform: translate(50%, -50%) rotate(0deg);
    -ms-transform: translate(50%, -50%) rotate(0deg);
  }

  #login {
    background-image: url("./../../assets/login_bg.jpg");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
  }

  #login {
    overflow: hidden;
  }

  #login .materialContainer {
    width: 100%;
    max-width: 460px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  *,
  *:after,
  *::before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    text-decoration: none;
    list-style-type: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Login/Login.vue